<template>
  <div class="login">
    <h1>Login</h1>
    <p>
      This is a temporary page to allow our developers to actually log into the
      app without using the shared login page
    </p>
    <v-btn @click="login">Login</v-btn>
  </div>
</template>
<script>
module.exports = {
  methods: {
    login: function () {
      const cookieValue =
        '9C1E811A0C767B79A7103C805E90DD73F16B35467CAEA1BAA77C62D2127B3A7376D342929F3D7B098D37B400BC919CB79752A835F6BC09CE3CE64E99C68D773D0159280692282058143450B5BB306BB0701386E26BA9A8CA31A2D2DB55CF6B6BCEB5FC386511A9D5DC64EF1CB4FD06D7E4A65C0FFE6156663F4C5FF8A4DF38B387BBB83A8BB2483F8293125DC6B3B2E51970FB1D'
      document.cookie = `APAUTH=${cookieValue};path=/`
      window.location = window.location.href.replace('/login', '/')
    },
  },
}
</script>
